import { render, staticRenderFns } from "./WhatsappTemplates.vue?vue&type=template&id=476e5c6c&"
import script from "./WhatsappTemplates.vue?vue&type=script&lang=ts&"
export * from "./WhatsappTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports